import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { SharedService } from './shared.service';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class CabService {

  constructor(private sharedapi: SharedService, private http: HttpClient) { }

  getCabDetails(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-cab-details/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  changeCabStatus(data,cabForm)
  {
      var formData: any = new FormData();
      for (const key in cabForm)
      {
          if(key=='pickup_date' && cabForm[key] != null)
          {
              formData.append(key, cabForm[key].getFullYear()+'-'+(cabForm[key].getMonth()+1)+'-'+cabForm[key].getDate());
          }else
          formData.append(key, cabForm[key]);
      }
      console.log(formData);
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-cab-status/'+data.ipd_id+'/'+data.status,formData,{headers:webheader})
  }

  getCabReport()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-cab-report',{headers:webheader})
  }

  getCabDetail(ipd_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-cab-detail/'+ipd_id,{headers:webheader})
  }

}
